import './CompteClient.scss';

import AddIcon from '@mui/icons-material/Add';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { Alert, Button } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { buttonStyles, buttonStylesBlue } from '../../../Components/docsAdministrative/JsObjectStyles';
import { IconTextField, SelectComponent, TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
import { isMontantOrCoeff } from '../../../data/Interfaces';
import usePostRequest from '../../../hooks/usePostRequest';
import { isHttpStatusSuccess } from '../../../Utils/utils';

function PrestationComplementaire({inputListHNO,setInputListHNO,nbrHrsHNOs,setNbrHrsHNOs,isMontant,inputListAstreinte,setInputListAstreinte,ClientId,setCheckUpdateValue,checkUpdateValue,disabled,setIsMontant}){

    PrestationComplementaire.propTypes = {
        ClientId: PropTypes.any,
        inputListHNO: PropTypes.any,
        setInputListHNO: PropTypes.func,
        nbrHrsHNOs: PropTypes.any,
        setNbrHrsHNOs: PropTypes.func,
        isMontant:PropTypes.any,
        inputListAstreinte: PropTypes.any,
        setInputListAstreinte: PropTypes.func,
        setCheckUpdateValue:PropTypes.func,
        checkUpdateValue:PropTypes.any,
        setIsMontant:PropTypes.func,
        disabled:PropTypes.any,
    };
    const {postData}= usePostRequest();
    const { i18n } = useTranslation();
    const location=useLocation();
    const handleInputChangeHNO = (e, index) => {
        const { name, value } = e.target;
        const list = [...inputListHNO];
        list[index][name] = value;
        setInputListHNO(list);
        setCheckUpdateValue(false);
    };

    // handle click event of the Remove button
    const handleRemoveClickHNO = (index) => {
        const list = [...inputListHNO];
        list.splice(index, 1);
        setInputListHNO(list);
    };

    // handle click event of the Add button
    const handleAddClickHNO = () => {
        setInputListHNO([...inputListHNO, { type: '', montant: '' }]);
    };

    const handleInputChangeAstreinte = (e, index) => {
        const { name, value } = e.target;
        const list = [...inputListAstreinte];
        list[index][name] = value;
        console.log('list', list);
        setInputListAstreinte(list);
        setCheckUpdateValue(false);
    };

    // handle click event of the Remove button
    const handleRemoveClickAstreinte = (index) => {
        const list = [...inputListAstreinte];
        list.splice(index, 1);
        setInputListAstreinte(list);
    };

    const handleKeyDown = (event) => {
        if (event.key === '-') {
            event.preventDefault();
        }
    };

    const enregistrerDonneesBackend = async () => {
        try {
            let endpoint = location.pathname.includes('gestionEsn') ? '/esn/updatePrestationsComplementaires':'/client/updatePrestationsComplementaires/';
            const response1 = await postData({url:endpoint, payload:
                {
                    ...(location.pathname.includes('gestionEsn')
                        ? { esnId: ClientId }
                        : { clientId: ClientId }),
                    astreintes: inputListAstreinte.filter((astr)=> astr?.type != ' ' && astr?.type && astr?.montant != ' ' && astr?.montant  ),
                    hnos: inputListHNO.filter((hno)=> hno?.type != ' ' && hno?.type && hno?.montant != ' ' && hno?.montant  ),
                    rules:{isMontant:isMontant=='Montant'?true:false,nbrHrsHNOs:nbrHrsHNOs}
                }}
            );
            // const response1 = await postData({
            //     url: `/${role}/updatePrestationsComplementaires`,
            //     payload: {
            //         ...(role === 'client' ? { clientId: ClientId } : { esnId: esnId }),
            //         astreintes: inputListAstreinte.filter(astr => astr?.type !== ' ' && astr?.type && astr?.montant !== ' ' && astr?.montant),
            //         hnos: inputListHNO.filter(hno => hno?.type !== ' ' && hno?.type && hno?.montant !== ' ' && hno?.montant),
            //         rules: {
            //             isMontant: isMontant === 'Montant',
            //             nbrHrsHNOs: nbrHrsHNOs
            //         }
            //     }
            // });
            if (isHttpStatusSuccess(response1?.responseStatus)){
                setCheckUpdateValue(true);
                console.log(response1);
            }
        } catch (error) {
            console.log(error.response?.status);
        }
    };

    // handle click event of the Add button
    const handleAddClickAstreinte = () => {
        setInputListAstreinte([...inputListAstreinte, { type: ' ', montant: ' ' }]);
    };

    return (
        <>
            <div className='frame0PrestationCompl'>
                <h4 className='titlesociete'>{i18n.t('Prestation Complémentaire')}</h4>

                <div className='frame3PrestationCompl'>
                    <h6 className='nomPrenomProfile'>{i18n.t('Astreintes')}</h6>
                    <div className='frame8PrestationCompl frame181PrestationCompl'>
                        <b className='frame9PrestationCompl'>{i18n.t('Coefficient/Montant')} </b>
                        <SelectComponent
                            // label={'Coefficient/Montant *'}
                            val={isMontant}
                            listVal={isMontantOrCoeff}
                            setVal={(e) => {
                                setIsMontant(e.target.value);
                                setCheckUpdateValue(false);
                            }}
                            disabled={disabled}
                        />
                    </div>
                    {inputListAstreinte.length<=0 ?
                        <div>{!disabled && <Alert severity="info">{i18n.t('Aucune donnée astreinte n\'est définie')}</Alert>}</div>
                        :
                        <>
                            {inputListAstreinte.map((x, i) => (
                                <div
                                    className='frame12PrestationCompl'
                                    key={i}
                                >
                                    <div className='frame8PrestationCompl'>
                                        <p className='frame9PrestationCompl'>{i18n.t('Type d\'astreinte')}</p>
                                        <div className='frame10PrestationCompl'>
                                            <TextFieldComponent
                                                id="outlined-name"
                                                // label="Siret"
                                                value={x.type}
                                                name='type'
                                                onChange={e => handleInputChangeAstreinte(e, i)}
                                                disabled={disabled}
                                                style={{width:'100%',borderRadius:'8px',backgroundColor:'white'}}
                                                sx={{
                                                    '& > :not(style)': {borderRadius:'8px' },

                                                }}

                                            />
                                        </div>
                                    </div>

                                    <div className='frame8PrestationCompl'>
                                        <p className='frame9PrestationCompl'>{isMontant=='Montant' ? 'Montant' : 'Coefficient'}</p>
                                        <div className='frame10PrestationCompl'>
                                            <IconTextField
                                                id="outlined-name"
                                                value={x.montant}
                                                onChange={e => handleInputChangeAstreinte(e, i)}
                                                disabled={disabled}
                                                name='montant'
                                                style={{width:'100%',borderRadius:'8px',backgroundColor:'white'}}
                                                iconEnd={isMontant=='Montant' ?'€':'%'}
                                                //InputProps={{ endAdornment:
                                                //    (<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">€</InputAdornment></div>)}}
                                                sx={{
                                                    '& > :not(style)': {borderRadius:'8px' },
                                                }}

                                            />
                                        </div>
                                    </div>
                                    {!disabled &&
                                    <div className='frame14PrestationCompl'>
                                        <div className='frame16PrestationCompl'>
                                            <IconButton
                                                onClick={() => {
                                                    handleRemoveClickAstreinte(i);
                                                    setCheckUpdateValue(false);
                                                }}
                                            >
                                                <DeleteForeverIcon />
                                            </IconButton>
                                        </div>
                                    </div>
                                    }
                                </div>
                            ))}
                        </>
                    }
                    {!disabled &&
                    <Button
                        onClick={() => {
                            handleAddClickAstreinte();
                            setCheckUpdateValue(false);
                        }}
                        style={{...buttonStyles()}}
                        startIcon={<AddIcon />}
                    >{i18n.t('Ajouter une Astreinte')}</Button>
                    }
                    <h6 className='nomPrenomProfile'>{i18n.t('HNO')}</h6>
                    <div className='frame8PrestationCompl frame181PrestationCompl'>
                        <b className='frame9PrestationCompl'>{i18n.t('Heures ouvrées')}</b>
                        <TextFieldComponent
                            id="outlined-name"
                            value={nbrHrsHNOs}
                            type='number'
                            disabled={disabled}
                            onChange={(e) => {
                                setNbrHrsHNOs(e.target.value);
                                setCheckUpdateValue(false);
                            }}
                            style={{ width: '100%', backgroundColor: 'white', borderRadius: '8px' }}
                            sx={{
                                '& > :not(style)': { borderRadius: '8px' },
                            }}
                        />
                    </div>
                    {inputListHNO.length<=0 ?
                        <div>{!disabled &&<Alert severity="info">{i18n.t('Aucune donnée HNO n\'est définie')}</Alert>}</div>
                        :
                        <>
                            {inputListHNO.map((x, i) => (
                                <div
                                    className='frame12PrestationCompl'
                                    key={i}
                                >
                                    <div className='frame8PrestationCompl'>
                                        <p className='frame9PrestationCompl'>{i18n.t('Type d\'HNO')}</p>
                                        <div className='frame10PrestationCompl'>
                                            <TextFieldComponent
                                                id="outlined-name"
                                                // label="Siret"
                                                value={x.type}
                                                disabled={disabled}
                                                name='type'
                                                onChange={e => handleInputChangeHNO(e, i)}
                                                style={{width:'100%',borderRadius:'8px',backgroundColor:'white'}}
                                                sx={{
                                                    '& > :not(style)': {borderRadius:'8px' },

                                                }}

                                            />
                                        </div>
                                    </div>
                                    <div className='frame8PrestationCompl'>
                                        <p className='frame9PrestationCompl'>{i18n.t('Coefficient')}</p>
                                        <div className='frame10PrestationCompl'>
                                            <TextFieldComponent
                                                id="outlined-name"
                                                // label="Siret"
                                                value={x.montant}
                                                type='number'
                                                name='montant'
                                                InputProps={{
                                                    inputProps: { min: 0,}
                                                }}
                                                disabled={disabled}
                                                onKeyDown={handleKeyDown}
                                                onChange={e => handleInputChangeHNO(e, i)}
                                                style={{width:'100%',borderRadius:'8px',backgroundColor:'white'}}
                                                sx={{
                                                    '& > :not(style)': {borderRadius:'8px' },

                                                }}

                                            />
                                        </div>
                                    </div>
                                    {!disabled &&
                                    <div className='frame14PrestationCompl'>
                                        <div className='frame16PrestationCompl'>
                                            <IconButton
                                                onClick={() => {
                                                    handleRemoveClickHNO(i);
                                                    setCheckUpdateValue(false);
                                                }}
                                            >
                                                <DeleteForeverIcon />
                                            </IconButton>
                                        </div>
                                    </div>
                                    }
                                </div>
                            ))}
                        </>

                    }
                    {!disabled &&
                    <Button
                        onClick={() => {
                            handleAddClickHNO();
                            setCheckUpdateValue(false);
                        }}
                        style={{...buttonStyles()}}
                        startIcon={<AddIcon />}
                    >{i18n.t('Ajouter un HNO')}
                    </Button>
                    }
                    {!disabled &&
                    <div className='frame17PrestationCompl'>
                        <div className='frame18PrestationCompl'>
                            <div className='frame19PrestationCompl'>
                            </div>
                            <div className='frame20PrestationCompl'>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    style={{...buttonStylesBlue(checkUpdateValue)}}
                                    disabled={checkUpdateValue}
                                    startIcon={<SaveOutlinedIcon />}
                                    onClick={enregistrerDonneesBackend}
                                //startIcon={<ArrowForward />}
                                >
                                    {i18n.t('Enregistrer')}
                                </Button>
                            </div>
                        </div>
                    </div>
                    }
                </div>

            </div>

        </>
    );

}

export default PrestationComplementaire;